import React, { Component } from 'react';
import styled from 'styled-components';
import { translate } from 'react-i18next';

import DeviceCard from '../elements/DeviceCard';
import Button from '../elements/Button';
import SendButton from '../elements/SendButton';
import Heading from '../elements/PageHeading';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  margin: auto;
  color: ${props => props.theme.secondary};
`;

const Buttons = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 50px auto 0px;
  width: 360px;
`;

const Attention = styled.div`
  background: ${props => props.theme.attentionTint};
  color: ${props => props.theme.secondary};
  width: 360px;
  padding: 15px;
  box-sizing: border-box;
  margin: 20px auto 0px;
  text-align: center;
`;

class OATPage extends Component {
  render() {
    const { t, target, cancel, enableOAT } = this.props;

    return (
      <Wrapper>
        <Heading text={t('management.OAT')} />
        <DeviceCard device={target || {}} />
        <div>
          <Attention>{t('management.enableOAT_warning')}</Attention>
          <Buttons>
            <Button onClick={cancel}>{t('button.cancel')}</Button>
            <SendButton
              onClick={() => enableOAT()}
              text={t('button.enableOAT')}
            />
          </Buttons>
        </div>
      </Wrapper>
    );
  }
}

export default translate()(OATPage);
